import { render } from "./EditEmisor.vue?vue&type=template&id=96d99d92"
import script from "./EditEmisor.vue?vue&type=script&lang=js"
export * from "./EditEmisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__